import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const initStateAdminProfileHistory = {
  adminProfileHistory: { data: null, loading: false, error: null },
};

export const adminProfileHistory = createAsyncThunk(
  "payment/adminProfileHistory",
  async (params = {}, { rejectWithValue, fulfillWithValue }) => {
    const token = localStorage.getItem("token");
    if (!token) return rejectWithValue({ error: "Необходима авторизация" });

    return await axios
      .get(`${process.env.REACT_APP_SERVER_API}/payments/apipay/admin/profile-history/`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((res) => fulfillWithValue(res.data))
      .catch((res) =>
        rejectWithValue(res.response?.data || { error: "Ошибка загрузки истории профилей" })
      );
  }
);

export const reducerAdminProfileHistory = {
  [adminProfileHistory.pending]: (state) => {
    state.adminProfileHistory.loading = true;
    state.adminProfileHistory.error = null;
  },
  [adminProfileHistory.fulfilled]: (state, action) => {
    state.adminProfileHistory.loading = false;
    state.adminProfileHistory.data = action.payload;
    state.adminProfileHistory.error = null;
  },
  [adminProfileHistory.rejected]: (state, action) => {
    state.adminProfileHistory.loading = false;
    state.adminProfileHistory.data = null;
    state.adminProfileHistory.error = action.payload;
  },
};
